import { render, staticRenderFns } from "./waitDelivery.vue?vue&type=template&id=f3e5cf7c&scoped=true"
import script from "./waitDelivery.vue?vue&type=script&lang=js"
export * from "./waitDelivery.vue?vue&type=script&lang=js"
import style0 from "./waitDelivery.vue?vue&type=style&index=0&id=f3e5cf7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e5cf7c",
  null
  
)

export default component.exports